export default __webpack_public_path__ + "static/media/background-03@2x.32d4b4ee.jpg";